import { useMutation } from "@tanstack/react-query";
import config from "configs/config";
import apiClient from "lib/api-client";

const updateUSPData = async (formData) => {
  const response = await apiClient.post(`${config.baseUrl}/api/v1/styles/updateStyleUSPData`, formData, {
    headers: {
      "Content-Type": undefined,
    },
  });
  return response.data;
};

export const useUpdateUSPData = () => {
  return useMutation({ mutationFn: updateUSPData });
};
